import CustomNote from './CustomNote';
export default {
  CustomNote,
};
